import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65367218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "filter-section__heading" }, "Filters", -1 /* HOISTED */))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "filter-section__filter-option" }
const _hoisted_6 = { class: "filter-section__filter-option" }
const _hoisted_7 = { class: "filter-section__filter-option" }
const _hoisted_8 = { class: "filter-section__filter-option" }

import FilterByCategory from './FilterByCategory.vue';
import FilterByRange from './FilterByRange.vue';

import { ref } from 'vue';
import { useResetQuery, viewQueryKey, sortQueryKey } from '@/composables';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterView',
  setup(__props) {


const ignoreParams = [viewQueryKey, sortQueryKey];

const { resetQuery } = useResetQuery(ignoreParams);
const copied = ref(false);

function copyLink() {
  navigator.clipboard.writeText(window.location.href).then(() => {
    copied.value = true;
    setTimeout(() =>  copied.value = false, 1500);
  });
}


return (_ctx: any,_cache: any) => {
  const _component_FadeTransition = _resolveComponent("FadeTransition")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      class: "btn filter-section__btn filter-section__btn_type_copy",
      onClick: copyLink
    }, [
      _createVNode(_component_FadeTransition, null, {
        default: _withCtx(() => [
          (copied.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Copied!"))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "Copy Link"))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("button", {
      class: "btn filter-section__btn filter-section__btn_type_reset",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(resetQuery) && _unref(resetQuery)(...args)))
    }, " Reset filters "),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(FilterByRange, { "key-of-product": "price" })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(FilterByRange, { "key-of-product": "stock" })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(FilterByCategory, { "key-of-product": "category" })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(FilterByCategory, { "key-of-product": "brand" })
    ])
  ]))
}
}

})